module.exports = {
  content: [
    "./pages/**/*.{js,ts,jsx,tsx}",
    "./components/**/*.{js,ts,jsx,tsx}",
  ],
  theme: {
    extend: {
      fontFamily: {
        brand: ["'Open Sans'", "sans-serif"],
      },
      colors: {
        primary: "#468365",
        brand: "#2A4B43",
        bone: "#FDFAF0",
        white: "#FFFEFC",
        blue: "#50649E",
        pink: "#F0CAB9",
        "pink-light": "#F5E8E2",
      },
    },
  },
  variants: {
    extend: {},
  },
  plugins: [],
};
